import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { ScanButton } from "@/components/BarcodeScanner";
import { TyreSetCard } from "@/components/TyreSetCard";
import { fieldInputCls } from "@/components/Field";
import { PageHeader } from "@/pages/Events";
import { useT } from "@/lib/i18n";
import { api } from "@/lib/api";

export default function TyreArchive() {
  const { t } = useT();
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [barcode, setBarcode] = useState("");
  const [sets, setSets] = useState(null);

  useEffect(() => {
    const id = setTimeout(() => {
      const params = { ...(q && { q }), ...(barcode.trim() && { barcode: barcode.trim() }) };
      api.get("/tyre-sets", { params }).then((r) => setSets(r.data));
    }, 250);
    return () => clearTimeout(id);
  }, [q, barcode]);

  const onScan = async (code) => {
    setBarcode(code);
    const { data } = await api.get("/tyre-sets", { params: { barcode: code } });
    if (data.length === 1) navigate(`/tyres/${data[0].id}?barcode=${encodeURIComponent(code)}`);
  };

  return (
    <div>
      <PageHeader title={t("tyres_archive_title")} sub={t("tyres_archive_sub")} image="/images/grid.jpg" imagePos="center 80%" />
      <div data-testid="tyre-archive-filters" className="bg-[#12141C] border border-[#282D3D] rounded-sm p-4 grid grid-cols-1 md:grid-cols-2 gap-3 mb-6">
        <div className="relative">
          <Search className="w-4 h-4 absolute left-3 top-3 text-slate-500" />
          <Input data-testid="tyre-archive-name-input" placeholder={t("search_set")} value={q} onChange={(e) => setQ(e.target.value)} className={`${fieldInputCls} pl-9`} />
        </div>
        <div className="flex gap-1.5">
          <Input data-testid="tyre-archive-barcode-input" placeholder={t("search_barcode")} value={barcode} onChange={(e) => setBarcode(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); onScan(barcode.trim()); } }} className={fieldInputCls} />
          <ScanButton testid="tyre-archive-scan-btn" onScan={onScan} />
        </div>
      </div>
      {sets && sets.length === 0 && (
        <div data-testid="tyre-archive-empty" className="border border-dashed border-[#282D3D] rounded-sm p-12 text-center text-slate-500 font-mono text-sm">
          {barcode.trim() ? `${t("barcode_not_found")}: ${barcode}` : t("no_tyre_sets")}
        </div>
      )}
      <div data-testid="tyre-archive-list" className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {sets?.map((s, i) => <TyreSetCard key={s.id} set={s} index={i} showEvent highlight={barcode.trim() || null} />)}
      </div>
    </div>
  );
}
